import api from './api.js'
import Cookies from 'js-cookie'

const TOKEN_KEY = 'auth_token'

export function getToken() {
  if (typeof window === 'undefined') return null
  try {
    return Cookies.get(TOKEN_KEY) || null
  } catch (_) { return null }
}

export function setToken(token) {
  if (typeof window === 'undefined') return
  try {
    const isLocalhost = location.hostname === 'localhost' || location.hostname === '127.0.0.1'
    
    const cookieOptions = {
      expires: 7, // 7 days
      path: '/',
      sameSite: 'lax'
    }
    
    // Add secure flag for HTTPS in production
    if (!isLocalhost && location.protocol === 'https:') {
      cookieOptions.secure = true
    }
    
    Cookies.set(TOKEN_KEY, token, cookieOptions)
  } catch (_) {}
}

export function clearToken() {
  if (typeof window === 'undefined') return
  try {
    Cookies.remove(TOKEN_KEY, { path: '/' })
  } catch (_) {}
}

export function isAuthenticated() {
  const t = getToken()
  return !!t
}

// login with email/password, expects backend to return { token } or {access_token}
export async function login(credentials) {
  // Use the api axios instance and call the admin login route so
  // the configured baseURL is used (avoid building full URLs here).
  const endpoint = '/admin/login'
  const resp = await api.post(endpoint, credentials)
  const data = resp.data || {}
  const token = data.token || data.access_token || data.accessToken || data.data?.token
  if (token) {
    setToken(token)
  }
  return data
}

export function logout() {
  clearToken()
}

export default { getToken, setToken, clearToken, isAuthenticated, login, logout }
